import React from 'react'

function CandidateScreening() {
    return (
        <div>
            CandidateScreening page
        </div>
    )
}

export default CandidateScreening
